import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center mt-4" }

import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { CollapsableModel } from "@/../../EshJSLib/models/CollapsableModel";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import vaccinazioni from "@/../../EshJSLib/models/form/vaccinazioni.json";
import vaccinazioniCalendar from "@/../../EshJSLib/models/form/vaccinazioniCalendar.json";
import { onMounted, reactive, ref } from "vue";
import { TblVaccinazione } from "@/../../EshJSLib/models/patient";
import vecciniEditCreate from '@/views/Vaccinazioni/vecciniEditCreate.vue'
import vacciniConfidenzialita from "@/views/Vaccinazioni/vacciniConfidenzialita.vue";
import AlertModal from "@/components/AlertModalFeedback.vue";
import loadingComponent from "@/components/loadingComponent.vue";
import { Farmaci } from "../../../../EshJSLib/models/farmaciModel";
import axios from "axios";
import { useRouter } from "vue-router";
import { Modal } from "flowbite-vue";
import { hasPermission } from "../../../../EshJSLib/services/securityServices";


export default /*#__PURE__*/_defineComponent({
  __name: 'VaccinazioniPage',
  setup(__props) {


const store = patientStore();
const { patient } = storeToRefs(store);
let indexgl = ref(null);
const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const modalAddEdit = ref<InstanceType<typeof vecciniEditCreate> | null>(null);
const modalConfidenzialita = ref<InstanceType<typeof vacciniConfidenzialita> | null>(null);
const showLoading = ref(false);

const router = useRouter();
const isShownModal = reactive({
  alert: false,
  movePage: false,
  confirm: false,
  alertMove: false,
});

function movePage() {
  router.push({ path: 'Paypal' })
}

onMounted(async () => {
  store.fetchVaccini();
})

function saveAndRefreshVaccini(row: TblVaccinazione) {
  showLoading.value = true;
  store.savePaziente(
    "tbl_vaccinaziones",
    row.id_vaccinazione
  )
    .then((x) => {
      store.fetchVaccini();
      showLoading.value = false;
      alertModal.value.openModal("Dati salvati con successo!", false)
    }, (error) => {
      store.fetchVaccini();
      showLoading.value = false;
      alertModal.value.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false)
    });
}

async function action(type: string, row: any, index: number, table: string) {
  switch (type) {
    case 'add':
      var id_tipo_licenza = patient.value.sottoscrizione.id_tipo_licenza
      if (await hasPermission('aggiungivaccini')) {
        row = {} as TblVaccinazione;
        row.id_vaccinazione = 0;
        row.author_id = patient.value.id_paziente;
        row.id_paziente = patient.value.id_paziente;
        row.id_livello_confidenzialita = 6
        row.vaccinidetails = {} as Farmaci;
        modalAddEdit.value.openModal('', row, 'Aggiungi nuovo vaccino').then((input) => {
          if (input) {
            patient.value.tbl_vaccinaziones.push(row);
            saveAndRefreshVaccini(row);
          }
        })
      } else {
        isShownModal.alert = true;
      }
      break;
    case 'pen':
      if (await hasPermission('modificavaccini')) {
        modalAddEdit.value.openModal('', row, 'Modifica il vaccino').then((input) => {
          if (input) {
            patient.value.tbl_vaccinaziones.push(row);
            saveAndRefreshVaccini(row);
          }
        })
      } else {
        isShownModal.alert = true;
      }
      break;
    case 'lock':
      modalConfidenzialita.value.openModal('', row).then((input) => {
        if (input) {
          patient.value.tbl_vaccinaziones.push(row);
          saveAndRefreshVaccini(row);
        }
      })
      break;
    case 'trash':
      row.deleted_at = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));
      alertModal.value.openModal("Sei sicuro di cancellare il record?", true).then((input) => {
        if (input) {
          patient.value.tbl_vaccinaziones.push(row);
          saveAndRefreshVaccini(row);
        }
      })
      break;
    case 'info':
      axios.get(`/farmacoDetails/` + row.vaccinidetails.id_farmaco_codifa).then((response) => {
        window.open(`/farmacoDetails/` + row.vaccinidetails.id_farmaco_codifa);
      }, (error) => {
        alertModal.value.openModal('Nessuna informazione di dettaglio per questo vaccino', false);
      })
      break;
  }
}

const dataModelCompletati = new CollapsableModel();

return (_ctx: any,_cache: any) => {
  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(vecciniEditCreate, {
          ref_key: "modalAddEdit",
          ref: modalAddEdit
        }, null, 512),
        _createVNode(vacciniConfidenzialita, {
          ref_key: "modalConfidenzialita",
          ref: modalConfidenzialita
        }, null, 512),
        _createVNode(AlertModal, {
          ref_key: "alertModal",
          ref: alertModal
        }, null, 512),
        (showLoading.value)
          ? (_openBlock(), _createBlock(loadingComponent, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(CollapsibleItem, {
          data: _unref(vaccinazioni),
          onRowActions: _cache[0] || (_cache[0] = (n, r, i) => action(n, r, i, 'ecluse')),
          onCreateForm: _cache[1] || (_cache[1] = ($event: any) => (action('add', null, null, 'ecluse')))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, { data: _unref(vaccinazioniCalendar) }, null, 8, ["data"]),
        (isShownModal.alert)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 1,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (isShownModal.alert = false))
            }, {
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (isShownModal.alert = false)),
                    type: "button",
                    class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                  }, _toDisplayString(_ctx.$t("Annulla")), 1),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (movePage())),
                    type: "button",
                    class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                  }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})